<template>
  <sg-text light-gray tag="div">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="h-auto w-8 inline"
      stroke="currentColor"
      fill="none"
    >
      <g
        class="nc-loop_dots-05-32"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <circle cx="16" cy="16" r="3" transform="translate(0 4.336)" />
        <circle cx="4" cy="16" r="3" transform="translate(0 6.336)" />
        <circle cx="28" cy="16" r="3" transform="translate(0 2.336)" />
      </g>

      <!-- prettier-ignore -->
      <script type="application/javascript">!function(){function t(t){this.element=t,this.dots=[this.element.getElementsByTagName("circle")[1],this.element.getElementsByTagName("circle")[0],this.element.getElementsByTagName("circle")[2]],this.animationId,this.start=null,this.init()}if(!window.requestAnimationFrame){var i=null;window.requestAnimationFrame=function(t,n){var e=(new Date).getTime();i||(i=e);var a=Math.max(0,16-(e-i)),o=window.setTimeout(function(){t(e+a)},a);return i=e+a,o}}t.prototype.init=function(){var t=this;this.animationId=window.requestAnimationFrame(t.triggerAnimation.bind(t))},t.prototype.reset=function(){var t=this;window.cancelAnimationFrame(t.animationId)},t.prototype.triggerAnimation=function(t){var i=this;this.start||(this.start=t);var n=t-this.start,e=Math.min(n/40,23);930>n||(this.start=this.start+930);for(var a=[],o=0;3>o;o++){a[o]=Math.max(e-2*o,0);if(a[o]>8)(a[o]=16-a[o]);a[o]=Math.max(a[o],0),this.dots[o].setAttribute("transform","translate(0 "+a[o]+")");}if(document.documentElement.contains(this.element))window.requestAnimationFrame(i.triggerAnimation.bind(i))};var n=document.getElementsByClassName("nc-loop_dots-05-32"),e=[];if(n)for(var a=0;n.length>a;a++)!function(i){e.push(new t(n[i]))}(a);document.addEventListener("visibilitychange",function(){"hidden"==document.visibilityState?e.forEach(function(t){t.reset()}):e.forEach(function(t){t.init()})})}();</script>
    </svg>
  </sg-text>
</template>

<script>
export default {
  computed: {
    dimensions() {
      switch (this.size) {
        case 10:
          return 'h-10 w-10';
        case 12:
          return 'h-12 w-12';
        case 14:
          return 'h-14 w-14';
      }
    },
  },
};
</script>
